import mask from 'jquery.maskedinput/src/jquery.maskedinput';
import openFormStatus from '../form/form';

$('#userSendDirectorPhone').mask("+7 (999) 999-99-99");

$("#SendDirector").submit(function(e) {
    e.preventDefault();

    const userMail = $("#userSendDirectorEmail").val(),
          userAccount = $("#userSendDirectorContart").val(),
          userName = $("#userSendDirectorName").val(),
          userPhone = $("#userSendDirectorPhone").val();
    let   userMsg = $("#userSendDirectorComment").val();
          userMsg = userAccount + "    " + userPhone+ "     " + userMsg;

    $.post("https://api.groupw.ru/fs/demands/director", {

        email:   userMail,
        text:    userMsg,
        contact: userName

    }, function(response) {

        200 == response.statusCode ? $.post("http://mtrend.ru/mail.php", {

            email_go:  userMail,
            dogovor:   userAccount,
            fio:       userName,
            telephone: userPhone,
            text:      userMsg

        }, function() {
          openFormStatus('Заявка отправлена', response.message);
        }) : penFormStatus('Заявка отправлена', response.message);
    });
});



// WEBPACK FOOTER //
// ./app/blocks/form-directions/form-directions.js